'use client';

import { Skeleton } from '@/components/atoms/Skeleton';
import useBreakpoint, { breakpointDesktopDefault } from '@/hooks/useBreakpoint';
import { theme } from '@/styles/theme';

export default function TermosFallback() {
  const { breakpoint } = useBreakpoint();
  const breakpointDesktopStyle =
    breakpoint === 'desktop' ? breakpointDesktopDefault : {};

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        padding: `${theme.spacing[5]}px ${theme.spacing[4]}px`,
        gap: theme.spacing[5],
        ...breakpointDesktopStyle,
      }}
    >
      <Skeleton style={{ height: 32, width: '60vw' }} />
      <Skeleton style={{ height: '80vh' }} />
    </div>
  );
}
